import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import isBridgeSite from "@workspace/casino_config/isBridgeSite";
import useSiteConfig from "./useSiteConfig";

const useSite = () => {
  const { site = "bitcasino", brand = "bitcasino" } = useAppContext();
  const siteConfig = useSiteConfig();
  const isSportsbet = site === "sportsbet";
  const isBitcasino = site === "bitcasino";
  return {
    site,
    brand,
    siteConfig,
    isSportsbet,
    isBitcasino,
    isBridgeSite: isBridgeSite(site),
  };
};

export default useSite;
